<template>
    <img style="padding:0;width:100%;height:122px;object-fit:cover;" :src='url'/>
</template>
<script>
export default{
    name:'ImageViewer',
    props:{
        url:{
            type: String,
            required:true
        }
    }

}
</script>